import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    poolName: 'Pool name',
    apy: 'APY',
    myPosition: 'My position',
    actions: 'Actions',
    delegateMore: 'Delegate more',
    withdraw: 'Withdraw',
  },
};
